/*Script for fix header*/
jQuery(window).scroll(function() {    
    var scroll = jQuery(window).scrollTop();
    if (scroll >= 50) {
        jQuery("header").addClass("fs-sticky-header");
    } else {
        jQuery("header").removeClass("fs-sticky-header");
    }
});
jQuery('.fs-galleryshow.owl-carousel').owlCarousel({
    loop:true,
    margin:0,
    autoWidth : false,
    responsiveClass:true,
    autoplay: false,
    autoplayTimeout:15000,
    nav:true,
    navText:["<i class='fas fa-chevron-left'></i>","<i class='fas fa-chevron-right'></i>"],
    responsive:{
        0:{
            items:1,
            nav:true
        },
        600:{
            items:1,
            nav:false
        },
        1000:{
            items:1,
            nav:true,
            loop:false
        }
    }
});